var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AgentService',{attrs:{"mcs-service-mode":2}})
}
var staticRenderFns = []

export { render, staticRenderFns }